import React, {useEffect, useState} from 'react'
import propTypes from 'prop-types'
import {get} from 'lodash';
import {gql} from "apollo-boost";
import styled from 'styled-components';
import {Grid} from '@material-ui/core';
import qs from 'qs';
import Router from 'next/router'
import TextField from '@material-ui/core/TextField';
import toPrice from '../../src/util/toPrice';
import ReactHtmlParser from 'react-html-parser';
import { v4 as uuidv4 } from 'uuid';

import jaycoClient from '../../src/graphql/jaycoClient';
// static functions
import client from '../../src/graphql/client';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorRepaymentCalculatorResults from '../../src/data-restructure/pages/repayment-calculator/results';
import refactorFinanceRates from '../../src/data-restructure/data/repayment-calc-rates';
import getPriceKey from '../../src/util/getPriceKey';
import PostcodePopup from '../../src/components/ui/SimplePostcodePopup';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';

import {theme} from '../../src/themes/default-theme';
import payment from '../../src/util/pmt';

// components
import Banner from '../../src/components/multimedia/Banner';
import BannerSlider from '../../src/components/multimedia/BannerSlider';
import Text from '../../src/components/typography';
import Cta from '../../src/components/ui/Cta';
// import Slider from '../../src/components/ui/Slider';
import Dropdown from '../../src/components/ui/Dropdown';
import RespImg from '../../src/components/ui/RespImg';
import seoQuery from '../../src/graphql/queries/seo';
import financeRatesQuery from '../../src/graphql/queries/finance-rates';
import Link from 'next/link';
import Calculator from '../../src/components/ui/Calculator';

const GridOrder = styled(props => {
  return <Grid {...props} mdorder={undefined}/>
})`
  ${theme.breakpoints.up("md")} {
    order: ${props => props.mdorder};
  }

  ${theme.breakpoints.up("lg")} {
    ${props => props.mdorder === '2' && `
      padding-left: 20px;
    `}
  }
`

const Container = styled.div`
  background-color: ${theme.palette.lightGrey};
`

const CalcContainer = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  overflow: hidden;
  ${theme.breakpoints.up("md")} {
    padding: 0 34px;
  }
`

const ModelDetails = styled.div`
  margin 35px 0;
  padding: 0 ${theme.containers.main.gutter};
  h4 {
    text-align: center;
  }
  ${theme.breakpoints.up("md")} {
    // margin: 114px 0;
    border-left: 1px solid ${theme.palette.middleGrey};
    height: 100%;
    padding: 0 0 0 ${theme.containers.main.gutter};
    h4 {
      text-align: left;
    }
  }

  ${theme.breakpoints.only("md")} {
    padding-right: 0;
  }

  ${theme.breakpoints.up("lg")} {
    padding-left: 0;
    padding-right: 0;
  }
`

const Results = styled.div `
  margin 35px 0;
  padding: 0 ${theme.containers.main.gutter};

  hr {
    border-top: 1px solid ${theme.palette.middleGrey};
    border-bottom: 0;
  }

  ${theme.breakpoints.only("md")} {
    padding: 0;
  }

  ${theme.breakpoints.up("lg")} {
    margin: 114px 0 0;
  }
`

const LoanDetails = styled.div`
  padding: 18px ${theme.containers.main.gutter} 0;
  position: relative;
  // background: ${theme.palette.lightBlue};
  height: 100%;

  ${theme.breakpoints.up("md")} {
    padding: 114px ${theme.containers.main.gutter} 0 0;
    max-width: 268px;
    &:before {
      content: '';
      position: absolute;
      width: 10000px;
      width: 50wv;
      height: 100%;
      right: 0;
      top: 0;
      // background: ${theme.palette.lightBlue};
      z-index: -1;
    }
  }

  ${theme.breakpoints.only("md")} {
    height: auto;
  }

  ${theme.breakpoints.up("lg")} {
    &:before {
      right: -70px;
    }
  }

  ${theme.breakpoints.up("lg")} {
    padding-left: 0;
    padding-right: 0;
  }
`

const CalcFields = styled.div`
  margin: 30px 0;
`

const CalcField = styled.div`
  margin: 24px 0;
`


const Input = styled(TextField)`
  width: 100%;
  
  input {
    padding-left: 24px;
    padding-right: 60px;
    background-color: white;
    border-radius: 55px;
    line-height: 15px;
    ::-webkit-input-placeholder { line-height: normal; }

    ${theme.breakpoints.down('sm')} {
      padding: 10px 45px 10px 14px;
    }
  }

  fieldset {
    border-radius: 55px;
  }
`

const Dropdowns = styled.div`
  // ${theme.breakpoints.up('md')} {
  //   display: flex;
  //   justify-content: space-between;
  // }
`

const DropdownItem = styled.div`
  margin-bottom: 20px;

  p {
      color: ${theme.palette.charcoal};
      margin-bottom: 8px;
  }

  ${theme.breakpoints.up('md')} {
    // max-width: 270px;
    // margin-bottom: 0;
    // width: 50%;
    // &:first-child {
    //   padding-right: 10px
    // }
    // &:last-child {
    //   padding-left: 10px
    // }
  }
`

const ModelImg = styled.div`
  margin: 40px 0;
  max-width: 550px;

  ${theme.breakpoints.down('md')} {
    margin-left: auto;
    margin-right: auto;
  }

`

const Price = styled.div`
  margin: 14px 0 25px;

  ${props => props.opacity === 1 && `
    opacity: 0.3;
  `}
  ${theme.breakpoints.up('md')} {
    
  }
`

const Repayments = styled.div`
  hr {
    margin: 15px 0;
  }
`

const RepaymentValues = styled.div`

`

const Repayment = styled.div`
  display: inline-block;
  min-width: 125px;
  margin-right: 20px;
  ${props => props.opacity === 1 && `
    opacity: 0.3;
  `}
`

const Ctas = styled.div`
  a {
    width: 216px;
    text-align: center;
    margin: 18px 0 0;
    display: block;

    ${theme.breakpoints.only('md')} {
      display: block;
    }
  }
`

const ResultsMedia = styled.div`
  ${props => props.mdOnly && `
    display: none;
  `}

  ${theme.breakpoints.only('md')} {
    ${props => props.mdOnly ? `
      display: block;
      margin-top: 60px;
    `: `
      display: none;
    `}
  }
`

const Disclaimers = styled.div`
  background-color: ${theme.palette.lightGrey};
  margin: 0 auto;
  padding: 50px ${theme.containers.main.gutter};
`

const DisclaimersContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  font-size: 10px;
`

const CalcResults = (props) => {

  const [series, setSeries] = useState({});
  const [activeSpec, setActiveSpec] = useState(null);
  const [models, setModels] = useState([]);
  const [model, setModel] = useState(null);
  const [activeModel, setActiveModel] = useState(null);
  const [loading, setLoading] = useState(false);
  const [repayments, setRepayments] = useState({
    week: null,
    month: null
  });
  const [pricingModal, setPricingModal] = useState(false);
  const [pricingKey, setPricingKey] = useState(false);

  const defaultLoanDetails = {
    deposit: '',
    term: props.rates.term,
    rate: props.rates.rate,
  }

  const interestRate = {
    min: 6.99,
    max: 16.45
  }

  const loanTerm = {
    min: 1,
    max: 7
  }

  const [loanDetails, setLoanDetails] = useState(defaultLoanDetails)
  const [price, setPrice] = useState(null);
  const [depositFocused, setDepositFocused] = useState(false)

  const redirect = () => {
    const redirectUrl = '/repayments-calculator';
    // To prevent any slow routing on development
    process.env.NODE_ENV === 'development' ?
      window.location.href = redirectUrl
    :
    Router.push(redirectUrl)
  }

  useEffect(() => {
    if (series.specs) {
      if (!activeSpec && series.specs[0]) {
        setActiveSpec(series.specs[0].title);
        const specModels = get(series, 'specs[0].models', []).map(item => {return {text: item.sizeText, value: item.modelName, id: get(activeModel, 'modelId', null) ? `${activeModel.modelId}_model_${item.modelName}` : null}});
        setModels(specModels);
        setModel(specModels[0]);
        // setActiveModel(get(series, 'specs[0].models[0]', null));
      }
    }
  }, [series])

  useEffect(() => {
    
    const key = getPriceKey();
    
    // Populate these items to specs
    if (!key) {
        setPricingModal(true);
    } else {
      setPricingKey(key);
    }
  },[])

  useEffect(() => {
    if (process.env.SHOW_PRICING === false) {
      window.location.href = '/';
    }
    const qsData = qs.parse(window.location.search.replace('?', ''));
    if (!qsData || !qsData.model) {
      redirect()
    } else {
      const seriesItem = props.series.find(item => {
        return item.seriesId === parseInt(qsData.model);
      })
      if (!seriesItem) {
        redirect()
      } else {
        setSeries(seriesItem);
      }
    }

  }, []);

  useEffect(() => {
    const spec = series.specs ? series.specs.find(item => item.title === activeSpec) : null;
    if (spec) {
      const newActiveModel = spec.models ? spec.models.find(item => item.modelName === model.value) : activeModel
      setActiveModel(newActiveModel);
    }
  }, [model]);

  useEffect(() => {
    const getModelPrice = async () => {

      const GET_MODEL_DATA = gql`
        query GetModel($id: ID!) {
          getModel(id: $id) {
            id
            priceAU
            priceAUNSW
            priceAUACT
            priceAUVIC
            priceAUQLD
            priceAUSA
            priceAUWA
            priceAUTAS
            priceAUNT
            priceNZ
          }
        }
      `
      setLoading(true);


      var priceKey;

      if (process.env.STATICLY_DEPLOYMENT_DESTINATION_DOMAIN.indexOf('jayco.com.au') !== -1 || window.location.hostname.indexOf('com-au') !== -1 || window.location.hostname.indexOf('com.au') !== -1) {
        // priceKey = 'priceAUNSW'
        priceKey = pricingKey
      } else {
        priceKey = 'priceNZ'
      }

      // override if in props
      if (priceKey) {
        const result = activeModel.modelId ? await jaycoClient.query({
          query: GET_MODEL_DATA,
          variables: {
            id: activeModel.modelId
          }
        }) : {}
        const priceVal = get(result, `data.getModel.${priceKey}`, null);
        setPrice(priceVal ? Math.ceil(priceVal) : null);
      }
      setLoading(false);

    }

    if (activeModel) {
      getModelPrice(activeModel);
    }

    return () => {
      jaycoClient.stop();
      setLoading(false);
    };

  }, [activeModel, pricingKey]);

  useEffect(() => {
    calculate();
  }, [loanDetails, price]);

  const calculateRepayment = (paymentFrequency) => {
    const {
      deposit,
      term,
      rate,
    } = loanDetails;

    const validateTerm = (term < loanTerm.min || isNaN(term)) ? loanTerm.min : term
    const validateRate = (rate < interestRate.min || isNaN(rate)) ? interestRate.min : rate

    const establishmentFee = props.rates.establishmentFee;
    const monthlyFee = props.rates.monthlyFee || 8.90;
    const onGoingFee = (monthlyFee * 12) / paymentFrequency;
    const loanAmount = price + establishmentFee - (deposit.toString().trim().length === 0 ? 0 : parseFloat(deposit));
    const calcInterestRate = parseFloat(((validateRate/100) / paymentFrequency));
    const periods = validateTerm * paymentFrequency;
    const pmt = payment(calcInterestRate, periods, loanAmount, 0, 1);
    const pmtWithFee = pmt - onGoingFee;
    return Math.abs(pmtWithFee)
  }

  const calculate = () => {
    const maxDepositDifference = 1
    const depositLessThanPrice = price ? ((loanDetails.deposit.toString().trim().length === 0 ? 0 : parseFloat(loanDetails.deposit) + maxDepositDifference) <= price) : true;
    if (!depositLessThanPrice) {
      setLoanDetails({
        ...loanDetails,
        deposit: price - maxDepositDifference // parseFloat(value)
      })
      return
    }    
    const repayments = {
      week: !price ? '-' : Math.round(calculateRepayment(52)),
      month: !price ? '-' : Math.round(calculateRepayment(12))
    }
    setRepayments(repayments)
  }

  const handleChange = (type, value) => {

    if (type === 'deposit') {
      const regex = /^[1-9]\d*(?:\.\d{0,2})?$/;
      if (!regex.test(value) && value.trim().length !== 0) {
        return
      }
    }

    setLoanDetails({
      ...loanDetails,
      [type]: value // parseFloat(value)
    })
  }

  const handleSpecChange = (e) => {
    setActiveSpec(e.value);
    const newActiveSpec = series.specs ? series.specs.find(item => item.title === e.value) : null;
    const newModels = newActiveSpec && newActiveSpec.models ? newActiveSpec.models.map(item => {return {text: item.sizeText, value: item.modelName}}) : null
    newModels && setModels(newModels);
    newModels && newModels[0] && setModel(newModels[0])
  }
  
  const formValsObj = activeModel ? {
    form_data: {
      model_id: activeModel.modelId,
      series_model_title: activeModel.seriesModelTitle,
      model_name: activeModel.modelName,
      price: '$' + toPrice(price),
      deposit: `$${loanDetails.deposit.length > 0 ? toPrice(loanDetails.deposit) : '0'}`,
      loan_term: loanDetails.term + ' years',
      interest_rate: loanDetails.rate + '%',
      repayments_per_week: '$' + toPrice(repayments.week),
      repayments_per_month: '$' + toPrice(repayments.month),
      url: window.location.href,
    }
  } : {}

  const formVals = activeModel ? qs.stringify(formValsObj) : ''
  const resultsUrl = `/repayments-calculator/results/form?${formVals}`

  const CalculatorContainer = styled.div`
      margin-top: 20px;
      margin-bottom: 40px;
      iframe {
        height: 700px;
        width: 100%; 
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
        display: block;
        border-radius: 15px;
        border: none;
      }

      ${theme.breakpoints.up('lg')} {
        margin: 75px 0 0;
      }
  `

  console.log('act', {activeModel, activeSpec, series, price});

  return (
  	<Container>
        {pricingModal &&
          <PostcodePopup
              open={true}
              onClose={() => {
                  setPricingModal(false);
                  setPricingKey('priceAUNSW');
                  const data = {
                    postcode: 2000
                  }
                  localStorage.setItem('userLocation', JSON.stringify(data));
              }}
              onSubmit={(postcode) => {
                const key = pricingKey ? pricingKey : getPriceKey(postcode);
                setPricingKey(key);
                setPricingModal(false);
            }}
          />
        }

      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          headingSize="large"
        />
      }
      {props.heroBannerSlider &&
        <BannerSlider
          {...props.heroBannerSlider}
        />
      }

      <CalcContainer>
        <Grid container direction={'row'} align={'left'} justify="space-between">
          
          <GridOrder item xs={12} md={6} lg={3} mdorder="1">
            <LoanDetails>
              <Text variant="h4" uppercase colour="charcoal">{series.title}</Text>
              {series.specs &&
                <CalcFields key={get(activeModel, 'modelId', uuidv4())}>
                  <Dropdowns>
                    <DropdownItem>
                    <Text variant="body1" element={'p'}>Select a model</Text>
                      <Dropdown
                        label={'Spec'}
                        options={series.specs.map(item => {
                          return {
                            text: item.title,
                            value: item.title,
                            id: get(activeModel, 'modelId', null) ? `${activeModel.modelId}_spec_${item.title}` : null
                          }
                        })}
                        value={activeSpec || undefined}
                        onChange={handleSpecChange}
                      />
                    </DropdownItem>
                    <DropdownItem>
                      <Text variant="body1" element={'p'}>Select a variant</Text>
                      <Dropdown
                        label={'Model'}
                        options={models}
                        value={model ? model.value : undefined}
                        onChange={(e) => setModel(e)}
                      />
                    </DropdownItem>
                  </Dropdowns>
                  <Link href="/repayments-calculator">Select another model</Link>

                </CalcFields>
              }
              {/* <CalcFields>
                <CalcField>
                  <Input
                    type="tel"
                    placeholder={'Deposit'}
                    onChange={(e) => handleChange('deposit', e.target.value)}
                    onFocus={() => setDepositFocused(true)} 
                    onBlur={() => setDepositFocused(false)}
                    variant="outlined"
                    value={!depositFocused && loanDetails.deposit.length > 0 ? '$' + toPrice(loanDetails.deposit) : loanDetails.deposit}
                  />
                </CalcField>
                <CalcField>
                  <Slider
                    title="Loan term"
                    defaultVals={[defaultLoanDetails.term]}
                    min={loanTerm.min}
                    max={loanTerm.max}
                    step={0.5}
                    bg={theme.palette.lightBlue}
                    afterLabel="years"
                    onSliderChange={(e) => handleChange('term', e[0])}
                    inputSize="small"
                    allowDecimals={true}
                  />
                </CalcField>
                <CalcField>
                  <Slider
                    title="Interest rate"
                    defaultVals={[defaultLoanDetails.rate]}
                    min={interestRate.min}
                    max={interestRate.max}
                    step={.01}
                    afterLabel="%"
                    bg={theme.palette.lightBlue}
                    onSliderChange={(e) => handleChange('rate', e[0])}
                    inputSize="small"
                    allowDecimals={true}
                  />
                </CalcField>
              </CalcFields> */}
            </LoanDetails>
            <ResultsMedia mdOnly={true}>
              {activeModel && price &&
                <CalculatorContainer>
                  <Calculator 
                    make="Jayco" // Jayco
                    price={price}
                    model={series.title} // All Terrain
                    variant={activeModel.modelName || ''} // JPOD.SP-MY23 or should it be 16ft?
                  />
                </CalculatorContainer>
              }
            </ResultsMedia>
          </GridOrder>
          <GridOrder item xs={12} md={6} lg={6} mdorder="2">
            <ModelDetails>
              {/* <Text variant="h4" uppercase colour="charcoal">Model details</Text> */}
              {series.specs &&
                <CalcFields key={get(activeModel, 'modelId', uuidv4())}>
                  {/* <Dropdowns>
                    <DropdownItem>
                      <Dropdown
                        label={'Spec'}
                        options={series.specs.map(item => {
                          return {
                            text: item.title,
                            value: item.title,
                            id: get(activeModel, 'modelId', null) ? `${activeModel.modelId}_spec_${item.title}` : null
                          }
                        })}
                        value={activeSpec || undefined}
                        onChange={handleSpecChange}
                      />
                    </DropdownItem>
                    <DropdownItem>
                      <Dropdown
                        label={'Model'}
                        options={models}
                        value={model ? model.value : undefined}
                        onChange={(e) => setModel(e)}
                      />
                    </DropdownItem>
                  </Dropdowns> */}

                  {activeModel &&
                    <>
                      <ModelImg>
                        <RespImg {...activeModel.image}/>
                      </ModelImg>
                      <ModelImg>
                        <RespImg {...activeModel.floorplan}/>
                      </ModelImg>
                    </>
                  }
                </CalcFields>
              }
            </ModelDetails>
          </GridOrder>
          
          <GridOrder item xs={12} md={6} lg={3} mdorder="3">
            <ResultsMedia mdOnly={false}>
          
                {activeModel && price &&
                  <CalculatorContainer>
                    <Calculator 
                      make="Jayco" // Jayco
                      price={price}
                      model={series.title} // All Terrain
                      variant={activeModel.modelName || ''} // JPOD.SP-MY23 or should it be 16ft?
                    />
                  </CalculatorContainer>
                }
        
            </ResultsMedia>
          </GridOrder> 
        </Grid>
      </CalcContainer>
      <Disclaimers>
        <DisclaimersContainer>
          {ReactHtmlParser(props.rates.disclaimer)}
        </DisclaimersContainer>
      </Disclaimers>
    </Container>
  )
}

const ResultsContainer = ({
    activeModel,
    price,
    repayments,
    loading,
    resultsUrl
  }) => {
    return (
      <Results>
        <Text variant="h6" colour="charcoal">{activeModel.seriesModelTitle}</Text>
        <br />
        <Text variant="subtitle1" colour="charcoal" uppercase>Floor plan: {activeModel.modelName}</Text>
        <hr />
        <Price opacity={loading ? 1 : 0}>
          <Text variant="h3" colour="charcoal">${price ? toPrice(price) : '--,---'}</Text>
        </Price>
        {repayments &&
          <Repayments>
            <Text variant="h6" colour="charcoal">Estimated repayments</Text>
            <hr />
            <RepaymentValues>
              <Repayment opacity={loading ? 1 : 0}>
                <Text variant="h3" colour="charcoal" uppercase>${repayments.week}</Text>
                <Text variant="subtitle1" colour="charcoal" uppercase>Per week</Text>
              </Repayment>
              <Repayment opacity={loading ? 1 : 0}>
                <Text variant="h3" colour="charcoal" uppercase>${repayments.month}</Text>
                <Text variant="subtitle1" colour="charcoal" uppercase>Per month</Text>
              </Repayment>
            </RepaymentValues>
          </Repayments>
        }

        <Ctas>
          <Cta href="/finance-enquiry" target="_blank">Make an enquiry</Cta>
          <Cta secondary href={resultsUrl}>Email Results</Cta>
          <Cta secondary outline href="/repayments-calculator">Go Back</Cta>
        </Ctas>

      </Results>
  )
}


export async function getStaticProps() {
  const GET_COMPARE = gql`
    query GET_MODELS($uri: String)  {
      pageBy(uri: $uri) {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        ${contentBuilderQuery()}
        acf_calculator_modal {
          cmCtaText
          cmTitle
          cmSubtext
          cbImage {
            ${respImgQuery}
          }
        }
      }
      series(first: 10000) {
        nodes {
          seriesId
          title
        }
      }
      ${financeRatesQuery}
      modelsFloorPlans(first: 10000) {
        nodes {
          title
          uri
          acf_floor_plan {
            modelHidePricing
            seriesSpec
            modelLayoutId
            modelLayoutName
            modelExternalImagesRep {
              modelExternalImagesRepImage {
                ${respImgQuery}
              }
            }
            modelFloorPlanImage {
              ${respImgQuery}
            }
            modelSeries {
              ... on Series {
                id
                seriesId
                acf_series {
                  seriesRange {
                    ... on Range {
                      uri
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      dealers(first: 1000) {
        nodes {
          title
          acf_dealers {
            dealerID
            latitude
            longitude
            postcodes
          }
        }
      }
    }
  `

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const pageProps = await client.query({
    query: GET_COMPARE,
    variables: {
      uri: `repayments-calculator?${countryCode}`
    }
  });

  const rates = refactorFinanceRates(pageProps, countryCode)

  const data = refactorRepaymentCalculatorResults(pageProps)

  const pageBy = pageProps ? get(pageProps, 'data.pageBy', null) : null;

  const assignedDomains = get(pageProps, 'data.pageBy.acf_domains.assignedDomains', []); 

  const breadcrumbs = await refactorBreadcrumbsData('/repayments-calculator/results', assignedDomains);

  return {
    props: {
      meta: {
        title: pageBy ? pageBy.title : null,
        seo: pageBy ? pageBy.seo : null,
        noIndex: true
      },
      breadcrumbs,
      ...data,
      rates,
      countryCode
    }
  }
}
  
CalcResults.propTypes = {
}
  
CalcResults.defaultProps = {
}
  
export default CalcResults